const state = {
  cantPorPagina: 10,
};

const mutations = {};

const store = {
  state,
  mutations,
  namespaced: true,
};

export default store;
